import Tile from "./Tile";
import Stack from "./Stack";

Tile.Stack = Stack;

export default Tile;
